var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7207 40.2388C32.2476 40.2388 39.9707 32.5157 39.9707 22.9888C39.9707 13.4619 32.2476 5.73877 22.7207 5.73877C13.1938 5.73877 5.4707 13.4619 5.4707 22.9888C5.4707 32.5157 13.1938 40.2388 22.7207 40.2388Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.9688V23.7504C22.5977 23.5993 22.172 23.5199 21.7422 23.5156C19.6542 23.5156 17.9688 25.2011 17.9688 27.2891C17.9688 29.377 19.6542 31.0625 21.7422 31.0625C23.6792 31.0625 25.2641 29.5951 25.4737 27.7083H25.5156V18.4844H27.8698C28.4221 18.4844 28.8698 18.0367 28.8698 17.4844V16.9688C28.8698 16.4165 28.4221 15.9688 27.8698 15.9688H23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audio-icon.5b0c40a1198ea242c936d6747d218003.svg";
export { ForwardRef as ReactComponent };